import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const ChartCard = ({ title, subtitle, children, loading, emptyMessage, isEmpty, action, headerExtra, className = '' }) => {
  return (
    <div
      className={`rounded-2xl border p-4 lg:p-5 flex flex-col ${className}`}
      style={{
        background: 'var(--vz-bg-card)',
        borderColor: 'var(--vz-border-subtle)',
        boxShadow: 'var(--vz-shadow-card)',
      }}
      data-testid="chart-card"
    >
      <div className="flex flex-col mb-4 gap-2">
        <div className="flex items-start justify-between gap-2">
          <div>
            <h3 className="font-montserrat text-xs font-bold uppercase tracking-[0.16em]" style={{ color: 'var(--vz-text-secondary)' }}>
              {title}
            </h3>
            {subtitle && (
              <p className="text-xs mt-0.5" style={{ color: 'var(--vz-text-muted)' }}>{subtitle}</p>
            )}
          </div>
          {action && <div className="flex-shrink-0">{action}</div>}
        </div>
        {headerExtra && <div>{headerExtra}</div>}
      </div>

      <div className="flex-1 min-h-0">
        {loading ? (
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" style={{ background: 'var(--vz-bg-elevated)' }} />
            <Skeleton className="h-4 w-3/4" style={{ background: 'var(--vz-bg-elevated)' }} />
            <Skeleton className="h-32 w-full" style={{ background: 'var(--vz-bg-elevated)' }} />
          </div>
        ) : isEmpty ? (
          <div className="flex flex-col items-center justify-center h-32 gap-2">
            <p className="text-sm" style={{ color: 'var(--vz-text-muted)' }}>
              {emptyMessage || 'No hay datos disponibles'}
            </p>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};
